module.exports = __webpack_public_path__ + "static/media/encore_logo_fr.380f6816.svg";